// 用户中心
export default [
    {
        path: '/instructions',
        component: () => import('@/pages/Mobile/Mine/children/Instructions.vue'),
        meta:{title:"使用说明"},
    },
    {
        path: '/login',
        component: () => import('@/components/Mobile/Login.vue'),
        meta:{title:"登录",transitionName: 'slide'},
    },
    {
        path: '/tbdetail',
        component: () => import('@/pages/Mobile/Mine/children/Tbdetail.vue'),
        meta:{title:"明细",requiresAuth:true},
    },
    {
        path: '/invitecode',
        component: () => import('@/pages/Mobile/Mine/children/InviteCode.vue'),
        meta:{title:"填写邀请码",requiresAuth:true},
    },
    {
        path: '/recharge',
        component: () => import('@/pages/Mobile/Mine/children/Recharge.vue'),
        meta:{title:"充值",requiresAuth:true},
    },
    {
        path: '/settings',
        component: () => import('@/pages/Mobile/Mine/children/Settings.vue'),
        meta:{title:"设置",requiresAuth:true},
    },
    {
        path: '/logout',
        component: () => import('@/pages/Mobile/Mine/children/Logout.vue'),
        meta:{title:"账号注销",requiresAuth:true},
    },
    // 用户须知
    {
        path:'/useragreement',
        component:()=> import('@/pages/Mobile/Mine/children/UserAgreement.vue'),
        meta:{
            title:"用户须知",
            requiresAuth:false,
        }
    }
]